<template>
  <div
    :class="{
      'scrollable-content': true,
      'scrollable-content--wide': wide,
    }">
    <loading-spinner v-if="loading" />
    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
  export default {
    props: [
      'wide',
      'loading',
    ]
  }
</script>

<style lang="scss" scoped>
  .scrollable-content {
    @apply
      w-full
      overflow-y-auto;
    height: calc(100% - 60px);

    &.scrollable-content--wide {
      height: 100%;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>